module.exports = __webpack_public_path__ + "img/soccerball.4f6a5dcc.svg";